import { createContext, useContext, useState } from 'react'

import { CameraCardItem } from '@shared'

type CardCollectionModalContextValues = {
  isOpen: boolean
  onIsOpenChange: (isOpen: boolean) => void
  currentCard: CameraCardItem | null
  onCurrentCardChange: (card: CameraCardItem) => void
}

const CardCollectionModalContext =
  createContext<CardCollectionModalContextValues | null>(null)

export const CardCollectionModalProvider = ({
  children,
}: {
  children: React.ReactNode
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const [currentCard, setCurrentCard] = useState<CameraCardItem | null>(null)

  return (
    <CardCollectionModalContext.Provider
      value={{
        isOpen,
        onIsOpenChange: setIsOpen,
        currentCard,
        onCurrentCardChange: setCurrentCard,
      }}
    >
      {children}
    </CardCollectionModalContext.Provider>
  )
}

export const useCardCollectionModal = () => {
  const context = useContext(CardCollectionModalContext)
  if (!context) {
    throw new Error(
      'useCardCollectionModal must be used within a CardCollectionModalProvider'
    )
  }
  return context
}

export const withCardCollectionModal = <P extends object>(
  Component: React.ComponentType<P>
) => {
  return function WithCardCollectionModal(props: P) {
    return (
      <CardCollectionModalProvider>
        <Component {...props} />
      </CardCollectionModalProvider>
    )
  }
}
